module.exports = __webpack_public_path__ + "static/media/icon_funding.4b41a699.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/RoadMap/icon_funding.svg
// module id = 1096
// module chunks = 0